import { render, staticRenderFns } from "./StylesButton.vue?vue&type=template&id=9bd41634&scoped=true"
import script from "./StylesButton.vue?vue&type=script&lang=js"
export * from "./StylesButton.vue?vue&type=script&lang=js"
import style0 from "./StylesButton.vue?vue&type=style&index=0&id=9bd41634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd41634",
  null
  
)

export default component.exports